import { useParams, Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { ProductDescription, ProductAdvantages, ProductCTA } from "@/components/sections/product"
import { ServiceHero, ServiceConditions } from "@/components/sections/service"
import { PageMeta } from "@/components/shared/PageMeta"
import SERVICES, { getServiceIdBySlug } from "@/content/services"
import { getServiceContent } from "@/content/services-content"
import { serviceOgImagePath } from "@/lib/seo"

export default function ServicioDetailPage(): React.JSX.Element {
	const { slug } = useParams<{ slug: string }>()
	const serviceId = slug ? getServiceIdBySlug(slug) : undefined

	if (!slug || !serviceId) {
		return (
			<>
				<PageMeta
					title="Servicio no encontrado"
					description="El servicio que buscas no existe o ya no está disponible."
					path={`/servicios/${slug ?? ""}`}
				/>
				<div className="mx-auto max-w-3xl px-4 py-20 text-center">
					<p className="text-lg text-muted-foreground">Servicio no encontrado.</p>
					<Button asChild className="mt-6">
						<Link to="/servicios">Volver a servicios</Link>
					</Button>
				</div>
			</>
		)
	}

	const service = SERVICES[serviceId]
	const content = getServiceContent(serviceId)
	const description = content.slogan ?? service.description

	return (
		<>
			<PageMeta
				title={service.name}
				description={description}
				image={serviceOgImagePath(serviceId)}
				path={`/servicios/${slug}`}
			/>
			<ServiceHero service={service} content={content} />
			<ProductDescription blocks={content.description} />
			<ProductAdvantages advantages={content.advantages} />
			{content.conditions && <ServiceConditions name={service.name} conditions={content.conditions} />}
			<ProductCTA item={service} cta={content.cta} />
		</>
	)
}
